import { EnterOutlined, SaveOutlined } from '@ant-design/icons'
import { Form, Input, notification, Popconfirm, Space, Button, Row, Col, Tabs, Card, InputNumber, Select } from 'antd'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { checkAccessRole, processedSlug, translate } from '../../../helper'
import { createCategory, detailCategory, updateCategory } from '../../../services/categoryService'
import { useSelector } from 'react-redux'
import { ACTION, MODULES } from '../../../config/const'

function BlogDetail() {
  const navigate = useNavigate()
  const [form] = Form.useForm()
  const [dataForm, setDataForm] = useState({})
  const [loading, setLoading] = useState(false)
  const [hostName, setHostName] = useState('')
  const [seo, setSeo] = useState({})
  const roles = useSelector((state) => state.permission).data;

  const params = useParams();

  const _detail = async (id) => {
    try {
      setLoading(true)
      const res = await detailCategory(id)
      if (!res.data || res.data.code !== 200) {
        return notification.warning({
          message: res.data.message,
        })
      }
      const { actived, parentId, name, ordering, categorieLangs, createdAt, urlThumbnail } = res.data.data;
      const dataform = {
        parentId,
        actived,
        categorieLangs,
        name,
        ordering,
        createdAt,
        urlThumbnail,
        categorieLangs: {}
      }
      for (let i = 0; i < categorieLangs.length; i++) {
        const { langCode } = categorieLangs[i];
        dataform.categorieLangs[langCode] = categorieLangs[i];
      }
      setDataForm(dataform)
      form.setFieldsValue(dataform)
    } catch (err) {
      console.log(err)
      notification.error({ message: err.message })
    } finally {
      setLoading(false)
    }
  }

  const submit = async () => {
    try {
      await form.validateFields();
      const { actived, name, ordering, categorieLangs, urlThumbnail } = form.getFieldsValue();
      const body = {
        name,
        ordering,
        parentId: 0,
        urlThumbnail,
        actived,
        categorieLangs: []
      };
      let isCheckTab = true;
      ['en', 'vi'].forEach(item => {
        if (!categorieLangs[item]) {
          isCheckTab = false
        }
      })
      if(!params.id && !isCheckTab){
        return notification.warning({ message: 'Vui lòng kiểm tra lại thông tin' })
    }
      for (const item in categorieLangs) {
        categorieLangs[item].langCode = item;
        categorieLangs[item].urlLink = categorieLangs['vi'].urlLink;
        if (params.id) { // type Update
          categorieLangs[item].id = dataForm.categorieLangs[item].id;
        }
        body.categorieLangs.push(categorieLangs[item])
      }
      if (!params.id) {
        const res = await createCategory(body)
        if (!res.data || res.data.code !== 200) {
          return notification.warning({
            message: res.data.message || 'Tạo chuyên mục thất bại vui lòng thử lại!',
          })
        }
        notification.success({ message: res.data.message })
      }
      if (params.id) {
        if (!checkAccessRole(roles, MODULES.EDITOR, ACTION.UPDATE)) {
          return notification.warning({
            message: 'Bạn không có quyền chỉnh sửa bài viết này',
          })
        }
        body.id = parseInt(params.id)
        const res = await updateCategory(body)
        if (!res.data || res.data.code !== 200) {
          return notification.warning({
            message: res.data.message || 'Chỉnh sửa chuyên mục thất bại vui lòng thử lại!',
          })
        }
        notification.success({ message: res.data.message })
      }
      navigate('/category')
    } catch (err) {
      if (err.errorFields?.length > 0) {
        return notification.warning({ message: 'Vui lòng kiểm tra lại thông tin' })
      }
      console.log(err)
      notification.error({ message: err.message })
    } finally {
    }
  }

  const changeHeading = (value, langCode) => {
    form.setFieldValue(['categorieLangs', langCode, 'urlLink'], processedSlug(value.target.value));
  }

  const blurHeading = (value, langCode) => {
    let categorieLangs = {
      vi: {},
      en: {}
    }
    categorieLangs[langCode].heading = value.target.value;
    setSeo(categorieLangs)
  }

  useEffect(() => {
    if (params.id) {
      _detail(params.id);
    }
  }, [params.id]);

  useEffect(() => {
    setHostName(process.env.REACT_APP_DOMAIN)
  }, []);

  const ContentTab = ({ langCode }) => {
    return (
      <>
        <div>
          <Form.Item
            name={['categorieLangs', langCode, 'heading']}
            label={translate("Tiêu đề", langCode)}
            rules={[{ required: true, message: 'Vui lòng nhập tiêu đề' }]}
          >
            <Input placeholder={translate("Nhập tiêu đề", langCode)} onInput={(value) => { changeHeading(value, langCode) }} onBlur={(value) => blurHeading(value, langCode)} />
          </Form.Item>
        </div>
        <Card type="inner" title="Tối ưu SEO" bordered={false}>
          <div>
            {translate("Thiết lập các thẻ mô tả giúp khách hàng dễ dàng tìm thấy danh mục này trên công cụ tìm kiếm như Google.", langCode)}
          </div>
          <div>
            Xem trước:
            <div className='yoast-seo'>
              <div className="sc-bSqbRM dlCkVf">
                <span className="screen-reader-text" >
                  Xem trước URL:</span>
                <div className="sc-tAEdG joWiup">
                  <div className="sc-tAEdG sc-dSfclH joWiup hgXshB">
                    <div className="sc-JkiRB hHABJO">
                      <img src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABs0lEQVR4AWL4//8/RRjO8Iucx+noO0MWUDo16FYABMGP6ZfUcRnWtm27jVPbtm3bttuH2t3eFPcY9pLz7NxiLjCyVd87pKnHyqXyxtCs8APd0rnyxiu4qSeA3QEDrAwBDrT1s1Rc/OrjLZwqVmOSu6+Lamcpp2KKMA9PH1BYXMe1mUP5qotvXTywsOEEYHXxrY+3cqk6TMkYpNr2FeoY3KIr0RPtn9wQ2unlA+GMkRw6+9TFw4YTwDUzx/JVvARj9KaedXRO8P5B1Du2S32smzqUrcKGEyA+uAgQjKX7zf0boWHGfn71jIKj2689gxp7OAGShNcBUmLMPVjZuiKcA2vuWHHDCQxMCz629kXAIU4ApY15QwggAFbfOP9DhgBJ+nWVJ1AZAfICAj1pAlY6hCADZnveQf7bQIwzVONGJonhLIlS9gr5mFg44Xd+4S3XHoGNPdJl1INIwKyEgHckEhgTe1bGiFY9GSFBYUwLh1IkiJUbY407E7syBSFxKTszEoiE/YdrgCEayDmtaJwCI9uu8TKMuZSVfSa4BpGgzvomBR/INhLGzrqDotp01ZR8pn/1L0JN9d9XNyx0AAAAAElFTkSuQmCC' alt="" className="sc-hYQoDq fTqTJk" />
                    </div>
                    <span className="sc-hZpJuv feGpeb">
                      <div className="sc-jvvkMf gYNhjI">{hostName}
                      </div><span className="sc-cHzrye bZphhk">{window.location.origin}</span> › {params.id} › {seo && seo.categorieLangs && seo.categorieLangs[langCode] ? seo.categorieLangs[langCode].heading : form.getFieldValue(['categorieLangs', 'vi', 'urlLink'])}</span>
                  </div>
                </div>
                <span className="screen-reader-text">
                  Xem trước tiêu đề SEO:</span>
                <div className="sc-gIBoTZ gMwUgP">
                  <div className="sc-fyrnIy sc-iWVLQz dwZvnc igrcjV">
                    <span className="sc-bUbQrF fbVpha">{seo && seo.categorieLangs && seo.categorieLangs[langCode] ? seo.categorieLangs[langCode].heading : form.getFieldValue(['categorieLangs', langCode, 'heading'])} - {hostName}</span>
                  </div>
                </div>
              </div>
              <div className="sc-bSqbRM dlCkVf">
                <span className="screen-reader-text" >Xem trước mô tả:</span>
                <div className="sc-dkQkSb gbobMG"><div className="sc-dkQkSb gbobMG">
                  <div className="sc-jivCuG hcnbXe">
                  </div><span className="sc-iWBMBB hThKVW">{params.id ? moment(dataForm.createdAt).format('MMM DD, YYYY') : moment().format('MMM DD, YYYY')} － </span>
                  {seo && seo.categorieLangs && seo.categorieLangs[langCode] ? seo.categorieLangs[langCode].seoDescription : form.getFieldValue(['categorieLangs', langCode, 'seoDescription'])}
                </div>
                </div>
              </div>
            </div>
          </div>
          <Form.Item
            name={['categorieLangs', 'vi', 'urlLink']}
            label={translate("Đường dẫn", langCode)}
            rules={[{ required: false }]}
          >
            <Input addonBefore="/" />
          </Form.Item>
          <Form.Item
            name={['categorieLangs', langCode, 'seoTitle']}
            label={translate("Tiêu đề trang", langCode)}
            rules={[{ required: false }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name={['categorieLangs', langCode, 'seoDescription']}
            label={translate("Mô tả trang", langCode)}
            rules={[{ required: false }]}
          >
            <Input.TextArea
              showCount
              maxLength={250}
              style={{
                height: 70,
                resize: 'none',
              }}
              onBlur={(value) => blurHeading(value, langCode)}
            />
          </Form.Item>
          <Form.Item
            name={['categorieLangs', langCode, 'seoKeywords']}
            label={translate("Seo từ khóa", langCode)}
            rules={[{ required: false }]}
          >
            <Input />
          </Form.Item>
        </Card>
      </>
    )
  }

  const TABS = [
    {
      label: 'Tiếng Việt',
      key: 'vi',
      children: <ContentTab langCode="vi"></ContentTab>
    },
    {
      label: 'Tiếng Anh',
      key: 'en',
      children: <ContentTab langCode="en"></ContentTab>
    }
  ]
  return (
    <Form
      form={form}
      layout="vertical"
      name="form_in_modal"
    >
      <Row className='mt-4' gutter={16}>
        <Col span={16}>
          <Tabs
            type="card"
            defaultActiveKey="2"
            items={TABS}
          />
        </Col>
        <Col span={8} className="mt-6">
          <div className="flex justify-end items-center">
            <Space>
              <Popconfirm
                title={!params.id ? 'Xác nhận để tạo chuyên mục' : 'Xác nhận để chỉnh sửa chuyên mục'}
                okText="Yes"
                cancelText="No"
                onConfirm={() => submit()}
              >
                <Button type="primary" loading={loading}>
                  <SaveOutlined />
                  Xác nhận
                </Button>
              </Popconfirm>
              <Button danger onClick={() => navigate('/category')}>
                <EnterOutlined />
                Quay lại</Button>
            </Space>
          </div>
          <Form.Item
            name="name"
            label={"Tên"}
            rules={[{ required: true, message: 'Vui lòng nhập tên' }]}
          >
            <Input placeholder={"Nhập tên"} />
          </Form.Item>
          <Form.Item
            name="ordering"
            label={"Sắp xếp"}
            style={{ width: "100%" }}
          >
            <InputNumber min={0} style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item
            label="Trạng thái"
            name="actived"
            rules={[{ message: 'Vui lòng chọn trạng thái', required: true }]}
          >
            <Select
              placeholder={'Chọn trạng thái'}
              style={{ width: '100%' }}
              options={[
                {
                  value: 1,
                  label: 'Hiển thị',
                },
                {
                  value: 0,
                  label: 'Ẩn hiển thị',
                },
              ]}
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  )
}

export default BlogDetail